<template>
  <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 4C14.896 4 14 3.104 14 2C14 0.896 14.896 -1.3568e-07 16 -8.74228e-08C17.104 -3.91654e-08 18 0.896 18 2C18 3.104 17.104 4 16 4Z" fill="currentColor"/>
    <path d="M11 2C11 0.896 10.104 -3.45145e-07 9 -3.93402e-07C7.896 -4.4166e-07 7 0.896 7 2C7 3.104 7.896 4 9 4C10.104 4 11 3.104 11 2Z" fill="currentColor"/>
    <path d="M4 2C4 0.895999 3.104 -6.51125e-07 2 -6.99382e-07C0.896 -7.4764e-07 -3.91654e-08 0.895999 -8.74228e-08 2C-1.3568e-07 3.104 0.896 4 2 4C3.104 4 4 3.104 4 2Z" fill="currentColor"/>
  </svg>
</template>
